module.exports = __webpack_public_path__ + "img/vvai.50bc8ae8.svg";